import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'highlight'
})
export class HighlightPipe implements PipeTransform {

  counter: number = 0;

  constructor(private sanitizer: DomSanitizer){}

  transform(value: any, args: string, regex: string): any {
    if (!args) {
      return value;
    }
    if (args.length == 1 && args == '.') {
      return value;
    }

    // Match in a case insensitive manner
    const re = new RegExp(args, regex);
    const match = value.match(re);

    // If there's no match, just return the original value.
    if (!match) {
      return value;
    }
    this.counter += 1;
    const replacedValue = value.replace(re, "<mark class='marked'>" + match[0] + "</mark>")
    return this.sanitizer.bypassSecurityTrustHtml(replacedValue)
  }

}
